<template>
  <!-- 相关租户信息 -->
  <el-drawer
    v-if="drawerShow"
    :title="title"
    :visible.sync="drawerShow"
    :wrapper-closable="false"
    :append-to-body="true"
    custom-class="configuration-drawer"
  >
    <div class="flex configuration-contanier">
      <div v-if="!pure" class="contanier-left">
        <div class="flex align-center">
          <el-input
            v-model="filterText"
            prefix-icon="el-icon-search"
            placeholder="请输入"
            @keyup.enter.native="getTreeData"
          />
          <el-button
            class="search-btn"
            type="primary"
            @click="getTreeData"
          >
            搜索
          </el-button>
        </div>
        <el-tree
          ref="tenantRef"
          v-loading="treeNodeLoading"
          class="tree"
          :data="tenantTree"
          node-key="tenantId"
          show-checkbox
          default-expand-all
          :default-checked-keys="checkKeys"
          :props="treeProps"
          check-strictly
          :filter-node-method="filterNode"
          @check="checkTree"
        />
      </div>
      <div class="contanier-right">
        <div class="flex choose justify-between align-center">
          <p>已选择 <span>{{ checkKeys.length }}</span>个 租户</p>
          <el-button
            v-if="!pure"
            type="text"
            @click="clearAll"
          >
            清空全部
          </el-button>
        </div>
        <template v-if="checkNodes.length">
          <div
            v-for="(item, index) in checkNodes"
            :key="item.tenantId"
          >
            <div class="flex  node-name flex-wrapper">
              <p class="ellipsis">
                {{ item.tenantName }}
              </p>
              <div class="code">
                {{ item.tenantId }}
              </div>
              <el-button
                v-if="!pure"
                class="btn-delete"
                type="text"
                @click="onDelete(index)"
              >
                删除
              </el-button>
            </div>
          </div>
        </template>
        <p v-else class="no-data">
          暂无数据
        </p>
      </div>
    </div>
    <div class="configuration-footer">
      <el-button @click="onClose">
        取 消
      </el-button>
      <el-button
        v-if="!pure"
        type="primary"
        :loading="loading"
        @click="onSubmit"
      >
        确定
      </el-button>
    </div>
  </el-drawer>
</template>

<script>
import { getTenantTree } from '@/api/common';

export default {
  props: {
    title: {
      type: String,
      default: '选择租户',
    },
    isInit: {
      type: Boolean,
      default: false,
    },
    closeImmediately: {
      type: Boolean,
      default: true,
    },
    pure: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      drawerShow: false,
      filterText: '',
      checkKeys: [],
      checkNodes: [],
      tenantData: [],
      tenantTree: [],
      treeNodeLoading: false,
      loading: false,
      treeProps: {
        children: 'children',
        label: 'tenantName',
      },
    };
  },
  created() {
    if (this.isInit) {
      this.getList();
    }
  },
  methods: {
    show(list = []) {
      this.filterText = '';
      this.checkKeys = list.map((item) => item.tenantId);
      this.checkNodes = list;
      this.drawerShow = true;
      if (this.isInit) return;
      this.getList();
    },
    async getList() {
      this.treeNodeLoading = true;
      const res = await getTenantTree({
        tenantId: 'T10',
      });
      this.treeNodeLoading = false;
      this.tenantTree = res;
      this.tenantData = res;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.tenantName.indexOf(value) !== -1;
    },
    getTreeData() {
      this.$refs.tenantRef.filter(this.filterText);
    },
    getFilterTree(list, dataTree = []) {
      list.forEach((item) => {
        if (item.tenantName.indexOf(this.filterText) > -1) {
          dataTree.push(item);
        } else if (item.children.length) {
          this.getFilterTree(item.children, dataTree);
        }
      });
      return dataTree;
    },
    clearAll() {
      this.checkKeys = [];
      this.checkNodes = [];
      this.$refs.tenantRef.setCheckedNodes([]);
    },
    onClose() {
      this.drawerShow = false;
      this.clearAll();
    },
    checkTree() {
      const res = this.$refs.tenantRef.getCheckedKeys();
      const nodes = this.$refs.tenantRef.getCheckedNodes();
      this.$set(this, 'checkKeys', res);
      this.$set(this, 'checkNodes', nodes);
    },
    // 删除
    onDelete(index) {
      this.$refs.tenantRef.setChecked(this.checkKeys[index], false);
      this.checkKeys.splice(index, 1);
      this.checkNodes.splice(index, 1);
    },
    getTenantReqs(data) {
      return data.map((item) => ({ code: item.tenantId, name: item.tenantName, type: 'TENANT' }));
    },
    async onSubmit() {
      if (this.closeImmediately) {
        this.$emit('getCheckNodes', this.checkNodes);
        this.drawerShow = false;
      } else {
        const close = () => {
          this.drawerShow = false;
        };
        this.$emit('getCheckNodes', this.checkNodes, close);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.configuration-footer {
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 24px 16px;
  width: 100%;
  text-align: right;
}
.flex-wrapper{
  display:flex;
  flex-wrap: nowrap;
  .ellipsis{
    // width:430px;
    flex:1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right:6px;
  }
  .code{
    width:170px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .btn-delete{
    width:50px;
    text-align: right;
  }
}
.configuration-contanier {
  height: calc(100% - 60px);
  > div {
    flex: 1;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 4px;
  }
  .contanier-right, .contanier-left {
    overflow-y: auto;
    padding: 24px;
    font-size: 14px;
  }
  .contanier-left {
    margin-right: 32px;
    .search-btn {
      margin-left: 16px;
    }
    .tree {
      margin-top: 18px;
    }
  }
  .contanier-right {
    .el-button {
      padding: 0;
    }
    .choose {
      color: rgba(0, 0, 0, 0.65);
      padding-bottom: 16px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.08);;
      span {
        color: rgba(0, 0, 0, 0.85);
      }
    }
    .node-name {
      height: 28px;
      line-height: 28px;
      margin-top: 16px;
      font-weight: 500;
    }
    .no-data {
      color: rgba(0, 0, 0, 0.25);
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
<style lang="scss">
.configuration-drawer {
  width: 1152px !important;
}
</style>
